import React, { useState } from "react";
import Recorder from "../QuestionPage/recorder";
import ExamPanel from "./ExamPanel";

const prompts = [
  "Your interests",
  "Your plans for future study",
  "Why you want to study abroad",
  "Why you need to learn English",
  "Why you chose this test",
];

export default function PersonalIntroductionPage({ onInputChange }) {
  const [text, setText] = useState("");

  const handleTextChange = (newText) => {
    if (newText !== text) {
      setText(newText);
      onInputChange(newText);
    }
  };

  return (
    <ExamPanel
      eyebrow="Speaking warm-up"
      title="Personal Introduction"
      instructions="Read the prompt below. In 25 seconds, reply in your own words as naturally and clearly as possible. You will have 30 seconds to give your response."
      questionLabel="Unscored item"
    >
      <div className="grid gap-6 lg:grid-cols-[minmax(280px,0.9fr),1.1fr] lg:items-start">
        <div className="rounded-md border border-slate-200 bg-slate-50 p-5">
          <p className="font-bold text-gray-900">
            Please introduce yourself. You may talk about one or more of the following:
          </p>
          <ul className="mt-4 list-disc space-y-2 pl-5 text-sm text-gray-600">
            {prompts.map((prompt) => (
              <li key={prompt}>{prompt}</li>
            ))}
          </ul>
        </div>

        <div className="rounded-md border border-slate-200 bg-white p-4">
          <Recorder
            text={text}
            setText={handleTextChange}
            duration={20}
            className="min-h-56 w-full rounded-md border border-slate-200 bg-slate-50"
          />
        </div>
      </div>
    </ExamPanel>
  );
}
